import { useRef, useState, useEffect } from "react";
import Skillcard from "../card/skillCard";
import htmlimg from "../../image/skill/html.png";
import cssimg from "../../image/skill/css.png";
import tailwindimg from "../../image/skill/tailwind.png";
import jsimg from "../../image/skill/js.png";
import jqueryimg from "../../image/skill/jquery.png";
import reactimg from "../../image/skill/react.png";
import phpimg from "../../image/skill/php.png";
import laravelimg from "../../image/skill/laravel.png";
import mysqlimg from "../../image/skill/mysql.png";

import Aos from "../aos/aos";

const Skills = () => {
    Aos(1000);
    const [counthtml, setcounthtml] = useState(0);
    const [runInterval, setRunInterval] = useState(false);
    const htmlref = useRef(null);

    const [countcss, setcountcss] = useState(0);
    const [runIntervalcss, setRunIntervalcss] = useState(false);
    const cssref = useRef(null);

    const [counttailwind, setcounttailwind] = useState(0);
    const [runIntervaltailwind, setRunIntervaltailwind] = useState(false);
    const tailwindref = useRef(null);

    const [countjs, setcountjs] = useState(0);
    const [runIntervaljs, setRunIntervaljs] = useState(false);
    const jsref = useRef(null);

    const [countjquery, setcountjquery] = useState(0);
    const [runIntervaljquery, setRunIntervaljquery] = useState(false);
    const jqueryref = useRef(null);

    const [countreact, setcountreact] = useState(0);
    const [runIntervalreact, setRunIntervalreact] = useState(false);
    const reactref = useRef(null);

    const [countphp, setcountphp] = useState(0);
    const [runIntervalphp, setRunIntervalphp] = useState(false);
    const phpref = useRef(null);

    const [countlaravel, setcountlaravel] = useState(0);
    const [runIntervallaravel, setRunIntervallaravel] = useState(false);
    const laravelref = useRef(null);

    const [countmysql, setcountmysql] = useState(0);
    const [runIntervalmysql, setRunIntervalmysql] = useState(false);
    const mysqlref = useRef(null);

    useEffect(() => {
        // html skill element observer
        const htmlobserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setRunInterval(true);
                } else {
                    setRunInterval(false);
                    setcounthtml(0);
                }
            });
        });
        htmlobserver.observe(htmlref.current);
   
        return () => {
            htmlobserver.disconnect();
            
        };
    }, []);

    useEffect(() => {
       
        // css skill element observer
        const cssobserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setRunIntervalcss(true);
                } else {
                    setRunIntervalcss(false);
                    
                }
            });
        });

        cssobserver.observe(cssref.current);
       

        return () => {
           
            cssobserver.disconnect();
        };
    }, []);
    useEffect(() => {
        const tailwindobserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setRunIntervaltailwind(true);
                } else {
                    setRunIntervaltailwind(false);   
                }
            });
        });
        tailwindobserver.observe(tailwindref.current);
        return () => {
            tailwindobserver.disconnect();
        };
    }, []);

    useEffect(() => {
        const jsobserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setRunIntervaljs(true);
                } else {
                    setRunIntervaljs(false);   
                }
            });
        });
        jsobserver.observe(jsref.current);
        return () => {
            jsobserver.disconnect();
        };
    }, []);

    useEffect(() => {
        const jqueryobserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setRunIntervaljquery(true);
                } else {
                    setRunIntervaljquery(false);   
                }
            });
        });
        jqueryobserver.observe(jqueryref.current);
        return () => {
            jqueryobserver.disconnect();
        };
    }, []);

    useEffect(() => {
        const reactobserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setRunIntervalreact(true);
                } else {
                    setRunIntervalreact(false);   
                }
            });
        });
        reactobserver.observe(reactref.current);
        return () => {
            reactobserver.disconnect();
        };
    }, []);
    useEffect(() => {
        const phpobserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setRunIntervalphp(true);
                } else {
                    setRunIntervalphp(false);   
                }
            });
        });
        phpobserver.observe(phpref.current);
        return () => {
            phpobserver.disconnect();
        };
    }, []);

    useEffect(() => {
        const laravelobserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setRunIntervallaravel(true);
                } else {
                    setRunIntervallaravel(false);   
                }
            });
        });
        laravelobserver.observe(laravelref.current);
        return () => {
            laravelobserver.disconnect();
        };
    }, []);
    
    useEffect(() => {
        const mysqlobserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setRunIntervalmysql(true);
                } else {
                    setRunIntervalmysql(false);   
                }
            });
        });
        mysqlobserver.observe(mysqlref.current);
        return () => {
            mysqlobserver.disconnect();
        };
    }, []);

    useEffect(() => {
        let interval;
        if (runInterval) {
            interval = setInterval(() => {
                setcounthtml((prevCount) => (prevCount < 90 ? prevCount + 1 : 90));
                
            }, 100);
        } else {
            clearInterval(interval);
        }

        return () => clearInterval(interval);
    }, [runInterval]);

    
    useEffect(() => {
        let intervalcss;
        if (runIntervalcss) {
            intervalcss = setInterval(() => {
                setcountcss((prevCount) => (prevCount < 97 ? prevCount + 1 : 97));
            
                
                
            }, 100);
        } else {
            clearInterval(intervalcss);
            setcountcss(0)
        }

        return () => clearInterval(intervalcss);
    }, [runIntervalcss]);
    useEffect(() => {
        let intervaltailwind;
        if (runIntervaltailwind) {
            intervaltailwind = setInterval(() => {
                setcounttailwind((prevCount) => (prevCount < 92 ? prevCount + 1 : 92));
            
                
                
            }, 100);
        } else {
            clearInterval(intervaltailwind);
            setcounttailwind(0)
        }

        return () => clearInterval(intervaltailwind);
    }, [runIntervaltailwind]);

    useEffect(() => {
        let intervaljs;
        if (runIntervaljs) {
            intervaljs = setInterval(() => {
                setcountjs((prevCount) => (prevCount < 89 ? prevCount + 1 : 89));
            
                
                
            }, 100);
        } else {
            clearInterval(intervaljs);
            setcountjs(0)
        }

        return () => clearInterval(intervaljs);
    }, [runIntervaljs]);

    useEffect(() => {
        let intervaljquery;
        if (runIntervaljquery) {
            intervaljquery = setInterval(() => {
                setcountjquery((prevCount) => (prevCount < 89 ? prevCount + 1 : 89));
            
                
                
            }, 100);
        } else {
            clearInterval(intervaljquery);
            setcountjquery(0)
        }

        return () => clearInterval(intervaljquery);
    }, [runIntervaljquery]);


    useEffect(() => {
        let intervalreact;
        if (runIntervalreact) {
            intervalreact = setInterval(() => {
                setcountreact((prevCount) => (prevCount < 88 ? prevCount + 1 : 88));
            
                
                
            }, 100);
        } else {
            clearInterval(intervalreact);
            setcountreact(0)
        }

        return () => clearInterval(intervalreact);
    }, [runIntervalreact]);
    useEffect(() => {
        let intervalphp;
        if (runIntervalphp) {
            intervalphp = setInterval(() => {
                setcountphp((prevCount) => (prevCount < 90 ? prevCount + 1 : 90));
            
                
                
            }, 100);
        } else {
            clearInterval(intervalphp);
            setcountphp(0)
        }

        return () => clearInterval(intervalphp);
    }, [runIntervalphp]);

    useEffect(() => {
        let intervallaravel;
        if (runIntervallaravel) {
            intervallaravel = setInterval(() => {
                setcountlaravel((prevCount) => (prevCount < 97 ? prevCount + 1 : 97));
            
                
                
            }, 100);
        } else {
            clearInterval(intervallaravel);
            setcountlaravel(0)
        }

        return () => clearInterval(intervallaravel);
    }, [runIntervallaravel]);
    useEffect(() => {
        let intervalmysql;
        if (runIntervalmysql) {
            intervalmysql = setInterval(() => {
                setcountmysql((prevCount) => (prevCount < 90 ? prevCount + 1 : 90));
            
                
                
            }, 100);
        } else {
            clearInterval(intervalmysql);
            setcountmysql(0)
        }

        return () => clearInterval(intervalmysql);
    }, [runIntervalmysql]);

    return (
        <div className="w-full mt-4 grid grid-cols-1 md:grid-cols-4 gap-y-4 place-items-center place-content-center">
            
            <div data-aos="fade-up" ref={htmlref}>
                <Skillcard
                    number={counthtml}
                    image={htmlimg}
                    text="As a web developer, I excel in creating well-structured and semantically meaningful web pages using HTML. My proficiency includes crafting clean and accessible markup to ensure a solid foundation for web development projects."
                />
            </div>
            <div data-aos="fade-up" ref={cssref}>
                <Skillcard
                    number={countcss}
                    image={cssimg}
                    text="With a keen eye for design and layout, I specialize in using CSS to style and enhance the visual appeal of websites. My expertise includes responsive design, flexbox, and grid layout, ensuring a seamless user experience across various devices."/>
            </div>
            <div data-aos="fade-up" ref={tailwindref}>
                <Skillcard
                    number={counttailwind}
                    image={tailwindimg}
                    text="I am adept at leveraging the power of Tailwind CSS to streamline the styling process. My proficiency includes using utility classes efficiently, resulting in a more maintainable and scalable codebase."
                />
            </div>
            <div data-aos="fade-up" ref={jsref}>
                <Skillcard
                    number={countjs}
                    image={jsimg}
                    text="As a skilled JavaScript developer, I bring interactivity and dynamic functionality to web applications. My proficiency includes DOM manipulation, asynchronous programming, and utilizing modern ES6+ features to create robust and efficient client-side scripts."
                />
            </div>
            <div data-aos="fade-up" ref={jqueryref}>
                <Skillcard
                    number={countjquery}
                    image={jqueryimg}
                    text="AI possess a strong command of jQuery, utilizing its concise syntax to simplify tasks and enhance the efficiency of client-side scripting. My experience includes seamlessly integrating jQuery into projects to achieve interactive and responsive web interfaces."
                />
            </div>
            <div data-aos="fade-up" ref={reactref}>
                <Skillcard
                    number={countreact}
                    image={reactimg}
                    text="I am proficient in building dynamic and scalable user interfaces using React. My expertise includes component-based architecture, state management, and integrating React into larger applications for a seamless and efficient development workflow."
                />
            </div>
            <div data-aos="fade-up" ref={phpref}>
                <Skillcard
                    number={countphp}
                    image={phpimg}
                    text="As a PHP developer, I excel in server-side scripting and building dynamic web applications. My proficiency includes working with PHP to handle form submissions, interact with databases, and implement server-side logic to create robust and feature-rich websites."
                />
            </div>
            <div data-aos="fade-up" ref={laravelref}>
                <Skillcard
                    number={countlaravel}
                    image={laravelimg}
                    text="I am skilled in using the Laravel framework to develop elegant and maintainable web applications. My expertise includes utilizing Laravel's features such as Eloquent ORM, routing, and middleware to create efficient and secure web solutions."
                />
            </div>
            <div data-aos="fade-up" ref={mysqlref}>
                <Skillcard
                    number={countmysql}
                    image={mysqlimg}
                    text="With a strong foundation in database design and management, I am proficient in using MySQL to store and retrieve data for web applications. My expertise includes writing optimized SQL queries and ensuring database efficiency for scalable and high-performance applications."
                />
            </div>
        </div>
    );
};

export default Skills;
